import React, { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophy, faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { withFirebase } from '../../firebase';

import Avatar from 'react-avatar';
import TournamentLoader from '../../loaders/TournamentLoader';
import ModalForm from '../../useful/ModalForm';
import ModalInfo from '../../useful/ModalInfo';
import PremiumUserDataForm from './PremiumUserDataForm';

const PremiumUserData = (props) => {

    const { loading, user } = props;
    const [modal, setModal] = useState({ show: false, title: '', message: '' });
    const [formShow, setFormShow] = useState(false);


    if (loading) {
        return (
            <div className="col p-2 m-0">
                <TournamentLoader />
            </div>
        )
    }

    const showTournamentForm = () => {
        setFormShow(true);
    }

    const showModal = (title, message) => {
        setModal({ show: true, title, message });
    }

    const userName = user && user.email ?
        user.email.substring(0, user.email.indexOf('@'))
        :
        "";
    const userDomain = user && user.email ?
        user.email.substring(user.email.indexOf('@'), user.email.length)
        :
        "";

    const color = user && user.blocked ? '#f88b97' : '#87f892';

    return (
        <>
            <div className="bg-hover-btn col p-2 ">
                <div className="d-flex flex-row align-items-center text-dark font-weight-bold mr-0 ml-0 2">
                    <Avatar textSizeRatio={1.7} className="align-self-center text-dark mr-2" maxInitials={2} name={user.email} size="30" round={true} color={color} />
                    <div className="flex-fill">
                        <span className="font-weight-bold">{userName}</span>
                    </div>
                    <button onClick={showTournamentForm} className="btn btn-second btn-sm ml-2" type="button" data-toggle="collapse" data-target="#offerFormCollapse" aria-expanded="true" aria-controls="offerFormCollapse">
                        <span className="d-none d-md-inline">Editar</span>
                        <FontAwesomeIcon className="ml-0 ml-md-2 " icon={faPencilAlt} />
                    </button>
                </div>

                <div className="mt-2" >
                    <ul className="list-group list-group-horizontal mb-0" style={{ fontSize: '0.9em', listStyleType: 'none' }}>
                        <li className="ml-1 text-center">
                            <FontAwesomeIcon className="mr-1 text-second" icon={faTrophy} />
                            <span className="text-nowrap">{(user.tournamentsCount || '0') + '/' + user.tournaments}</span>
                        </li>
                    </ul>
                </div>
            </div >

            <ModalInfo
                data={modal}
                onClose={() => setModal({ show: false, title: '', message: '' })}
            />

            <ModalForm
                show={formShow}
                onClose={() => setFormShow(false)}
            >
                <PremiumUserDataForm user={user}
                    showModal={showModal} isOpen={formShow}
                    onClose={() => setFormShow(false)} />
            </ModalForm>
        </>
    )

}

// export default withFirebase(React.memo(TournamentListItem));
export default withFirebase(PremiumUserData);
